module.exports = __webpack_public_path__ + "static/media/demo-store-1-SG.332cfbaf.jpg";